






















































import { Component, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderGetters } from "@/store/modules/order/types";
import { GlobalActions, GlobalGetters } from "@/store/modules/global/types";
import { Order } from "@/models/order/order";
import { PriceLevel } from "@/models/netsuite/netsuite";
import Vue from "vue";

@Component
export default class EditMultiplier extends Vue {
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrder))
  storeOrder!: Order;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetMultiplier))
  multiplier!: PriceLevel | null;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetPriceLevels))
  storePriceLevels!: PriceLevel[];
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: PriceLevel | null) => Promise<void>;

  @Prop({ default: "btn btn-sm border border-white text-white bg-brand-700 hover:bg-brand-600" })
  buttonClass!: string;

  @Prop({ default: "" })
  wrapClass!: string;

  @Prop({ default: false })
  disabled!: boolean;

  protected selectedPriceLevelId: number | null = null;
  protected showModal = false;

  @Watch("multiplier")
  private onStoreMultiplierChange(level: PriceLevel | null): void {
    this.selectedPriceLevelId = level?.id ?? null;
  }

  async created() {
    const isValidMultiplier =
      this.multiplier !== null &&
      typeof this.multiplier === "object" &&
      typeof (this.multiplier as any).id === "number";
    if (!isValidMultiplier && this.multiplier !== null) {
      await this.addMultiplier(null);
    }
    if (isValidMultiplier) {
      this.selectedPriceLevelId = (this.multiplier as PriceLevel).id;
    } else if (this.storeOrder?.customer_netsuite_price_level_id) {
      const match = this.storePriceLevels.find(
        l => l.id === this.storeOrder.customer_netsuite_price_level_id
      );
      if (match) {
        this.selectedPriceLevelId = match.id;
        await this.addMultiplier(match);
      }
    }
  }

  protected get hasCustomerDefault(): boolean {
    return this.storeOrder?.customer_netsuite_price_level_discount != null;
  }

  protected get customerDefaultMultiplierDisplay(): string {
    const discount = this.storeOrder?.customer_netsuite_price_level_discount;
    if (discount == null) return "";
    const value = 1 + discount;
    const match = this.storePriceLevels.find(
      l => l.id === this.storeOrder.customer_netsuite_price_level_id
    );
    return match ? match.name : `${value}`;
  }

  protected get multiplierValue(): number {
    if (!this.multiplier || this.multiplier.discountpct == null) return 1;
    return 1 + this.multiplier.discountpct;
  }

  protected onPriceLevelChange(): void {
    const level =
      this.storePriceLevels.find(l => l.id === this.selectedPriceLevelId) ??
      null;
    this.addMultiplier(level);
    this.$emit("change", level);
  }
}
